import React from 'react'
import PropTypes from 'prop-types'
import useOcapiSite from '../../hooks/useOcapiSite'
import {useKlarna} from '../klarna-pay-later/context'
import PaypalPayLater from '../paypal-pay-later'
import KlarnaPayLater from '../klarna-pay-later'

const PayLater = ({
    amount,
    currency,
    klarnaPlacement,
    paypalPlacement,
    uspPayLaterShowAll: showAll
}) => {
    const {enablePaypalLater, paypalLaterClientID} = useOcapiSite().customPreferences
    const {options: klarnaOptions} = useKlarna()
    const isPaypalEnabled =
        enablePaypalLater && paypalLaterClientID && amount > 0 && currency && paypalPlacement
    const isKlarnaEnabled = klarnaOptions.enabled && klarnaPlacement && amount > 0

    if (showAll && isPaypalEnabled && isKlarnaEnabled) {
        return (
            <>
                <PaypalPayLater amount={amount} currency={currency} placement={paypalPlacement} />
                <KlarnaPayLater amount={amount} placement={klarnaPlacement} />
            </>
        )
    } else if (isPaypalEnabled) {
        return <PaypalPayLater amount={amount} currency={currency} placement={paypalPlacement} />
    } else if (isKlarnaEnabled) {
        return <KlarnaPayLater amount={amount} placement={klarnaPlacement} />
    } else {
        return null
    }
}

PayLater.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    klarnaPlacement: PropTypes.string,
    paypalPlacement: PropTypes.string,
    uspPayLaterShowAll: PropTypes.bool
}

export default PayLater
